import React, { useState, memo, useCallback } from 'react';
import { SidebarPropTypes } from 'core/propTypes/sidebar-filters.propTypes';
import { useSidebarEffects } from '../../../core/hooks/useSidebarEffects';
import FilterSection from './components/FilterSection';
import { DEFAULTS, BUTTON_TEXTS } from '../../../core/constant/constants';
import './sidebar-filters.css';

const PlaceholderFilterSection = () => (
    <div className="ltn__menu-widget">
        <button className="filter-section-toggle pb-0">
            <a to="#" style={{ textTransform: 'capitalize', backgroundColor: '#e0e0e0', color: '#e0e0e0' }}> Loading... </a>
            <i className="fas fa-chevron-down" style={{ color: '#e0e0e0' }} />
        </button>
        <div className="filter-section-content" style={{ maxHeight: '0px' }}>
            <ul>
                {[...Array(5)].map((_, index) => (
                    <li key={index}>
                        <label className="checkbox-item" style={{ textTransform: 'capitalize', backgroundColor: '#e0e0e0', color: '#e0e0e0' }}>
                            Loading...
                            <input type="checkbox" disabled />
                            <span className="checkmark" />
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

const Sidebar = memo(({
    filters,
    onFilterChange,
    title = DEFAULTS.TITLE,
    columnSize = DEFAULTS.COLUMN_SIZE,
    onClearFilters,
    loading,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    useSidebarEffects(isOpen, setIsOpen);

    const handleOverlayClick = useCallback(() => setIsOpen(false), []);
    const toggleSidebar = useCallback(() => setIsOpen(prev => !prev), []);
    const handleClearFilters = useCallback(() => {
        onClearFilters();
        setIsOpen(false);
    }, [onClearFilters]);

    return (
        <div className={`${columnSize} mb-100`}>
            {isOpen && <div className="sidebar-overlay" onClick={handleOverlayClick} />}

            <button
                className={`sidebar-toggle-btn d-lg-none ${isOpen ? 'hidden' : ''}`}
                onClick={toggleSidebar}
            >
                <i className="fas fa-filter" />
                {BUTTON_TEXTS.FILTERS}
            </button>

            <aside className={`sidebar ltn__shop-sidebar ${isOpen ? 'show-sidebar' : ''}`}>
                <div className="sidebar-inner">
                    <button
                        className="close-sidebar-btn d-lg-none"
                        onClick={handleOverlayClick}
                    >
                        <i className="fas fa-times" />
                    </button>
                    <h4 className="mb-3">{title}</h4>
                    <div className="widget py-3" style={{ padding: '0 32px', textAlign: 'right' }}>
                        {/* <a className="text-danger mt-3 f-weight-800" style={{ cursor: 'pointer', fontWeight: '700', textAlign: 'right' }} onClick={handleClearFilters}>
                            Limpiar Filtros
                        </a> */}
                        {loading ? (
                            [...Array(3)].map((_, index) => (
                                <PlaceholderFilterSection key={index} />
                            ))
                        ) : (
                            filters?.map((section, index) => (
                                <FilterSection
                                    key={section.id}
                                    section={section}
                                    onFilterChange={onFilterChange}
                                    defaultOpen={index === 0}
                                />
                            ))
                        )}
                    </div>
                </div>
            </aside>
        </div>
    );
});

export default Sidebar;